import { render, staticRenderFns } from "./filterMarketPlace.vue?vue&type=template&id=4e5058c2&scoped=true&"
import script from "./filterMarketPlace.vue?vue&type=script&lang=js&"
export * from "./filterMarketPlace.vue?vue&type=script&lang=js&"
import style0 from "./filterMarketPlace.vue?vue&type=style&index=0&id=4e5058c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5058c2",
  null
  
)

export default component.exports